import { render, staticRenderFns } from "./OpeningsDays.vue?vue&type=template&id=c58aaae2&"
import script from "./OpeningsDays.vue?vue&type=script&lang=js&"
export * from "./OpeningsDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormRadio, BFormRadioGroup, BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BFormRadio, BFormRadioGroup, BCol, BRow, BContainer})
    

export default component.exports